import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { SideMenuBoxRecoil } from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import { ApiService } from '@/api';
import { UserInforDto } from '@/model/user.dto';

const Header = () => {
  const api = useMemo(() => new ApiService(), []);
  const navigate = useNavigate();

  const [sideMenuBoxState, setSideMenuBoxState] =
    useRecoilState(SideMenuBoxRecoil);

  const [userInfor, setMyInfor] = useState<UserInforDto | null>(null);

  const fetchUserInfor = async () => {
    try {
      const response: UserInforDto = await api.getMyInfor(
        String(sessionStorage.getItem('accessToken')),
      );
      setMyInfor(response);
    } catch (err: any) {
      if (err.response.data.statusCode === 401) {
        sessionStorage.clear();
        navigate('/login');
      }
    }
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/login');
  };

  useEffect(() => {
    fetchUserInfor();
  }, []);

  return (
    <>
      <Wrap className="flex aic jce">
        <span className="logo-box img-box">
          <img src="./img/logo.svg" alt="" />
        </span>
        <Box className="flex aic">
          <span className="text tm">{userInfor?.name}</span>
          <span className="line"></span>
          <button className="text tm" type="button" onClick={handleLogout}>
            로그아웃
          </button>
          <button
            className="ham-btn img-box"
            type="button"
            onClick={() => setSideMenuBoxState(true)}
          >
            <img src="./img/ico_ham_444.svg" alt="" />
          </button>
        </Box>
      </Wrap>
    </>
  );
};

export default Header;

const Wrap = styled.div`
  width: 100%;
  height: 72px;
  box-sizing: border-box;
  padding: 0 56px;
  border-bottom: 1px solid #eeeeff;
  > .logo-box {
    display: none;
  }
  @media (max-width: 1420px) {
    justify-content: space-between;
    height: 60px;
    padding: 0 20px;
    > .logo-box {
      display: block;
      width: 116px;
    }
  }
`;

const Box = styled.div`
  gap: 16px;
  .text {
    color: #444;
    font-size: 14px;
  }
  .line {
    width: 1px;
    height: 12px;
    background: #e9e8e8;
  }
  .btn {
    font-size: 14px;
    color: #444;
  }
  .ham-btn {
    display: none;
  }
  @media (max-width: 1420px) {
    .ham-btn {
      display: block;
      width: 20px;
      margin-left: 12px;
    }
  }
`;
